export const testimonials = [
  {
    quote:
      'Literalmente me salvó la vida. Daba 15 clases por semana y no me daba la cabeza para planificar. Ahora abro el tomo, leo 5 minutos y tengo una clase hermosa armada.',
    initials: 'VR',
    name: 'Valentina R.',
    location: 'Palermo, CABA',
  },
  {
    quote:
      'Lo que más me gustó son los temas filosóficos. Siempre me costaba integrarlos sin sonar aburrida. Ahora mis alumnas me dicen que las clases tienen mucha más profundidad.',
    initials: 'SM',
    name: 'Sofía M.',
    location: 'Córdoba Capital',
  },
  {
    quote:
      'El módulo de Yoga Terapéutico vale oro. Me sentía muy insegura cuando venían alumnas con dolor lumbar, ahora tengo protocolos claros para cuidarlas.',
    initials: 'CG',
    name: 'Camila G.',
    location: 'Rosario, Santa Fe',
  },
  {
    quote:
      'Por lo que sale es un regalo. Solo el tracker anual y los captions de Instagram ya me ahorraron horas de laburo. Muy recomendado para profes que recién arrancan.',
    initials: 'ML',
    name: 'Martina L.',
    location: 'Mendoza',
  },
  {
    quote:
      'Las secuencias son súper fluidas y lógicas. Mis alumnas notaron el cambio enseguida, las clases se sienten mucho más profesionales y armadas.',
    initials: 'LP',
    name: 'Lucía P.',
    location: 'La Plata, Buenos Aires',
  },
  {
    quote:
      'Me encanta que esté pensado para acá. El bono sobre el negocio del yoga me abrió la cabeza sobre cómo cobrar y valorar mi trabajo en pesos. ¡Gracias!',
    initials: 'AC',
    name: 'Andrea C.',
    location: 'Mar del Plata',
  },
]
